// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiot-input-select-popover .aiot-design-popover-inner-content {
  padding: 0;
}
.aiot-input-select-popover .aiot-input-select-table-row-active {
  background: #fff7e7;
  color: #E14C46;
}
.aiot-input-select-popover .wui-table-row-hover {
  cursor: pointer;
}
.aiot-input-select-popover .wui-table-page {
  margin: 0;
}
.aiot-input-select-select {
  width: 100%;
}
.aiot-input-select-select:not(.aiot-design-select-multiple) .aiot-design-select-selector {
  height: 28px!important;
}
`, "",{"version":3,"sources":["webpack://./src/components/InputSelect/src/index.less"],"names":[],"mappings":"AAGA;EAEI,UAAA;AAHJ;AACA;EAKI,mBAAA;EACA,cAAA;AAHJ;AAHA;EASI,eAAA;AAHJ;AANA;EAYI,SAAA;AAHJ;AAMA;EACE,WAAA;AAJF;AAmBA;EAEI,sBAAA;AAlBJ","sourcesContent":["@import '../../../assets/style/prefix.less';\n// @input-select-prefix-cls: ~'aiot-input-select';\n\n.aiot-input-select-popover{\n  .aiot-design-popover-inner-content{\n    padding: 0;\n  }\n  .aiot-input-select-table-row-active{\n    background: #fff7e7;\n    color: #E14C46;\n  }\n  .wui-table-row-hover{\n    cursor: pointer;\n  }\n  .wui-table-page {\n    margin: 0;\n  }\n}\n.aiot-input-select-select{\n  width: 100%;\n}\n\n\n//.aiot-input-select-popover{\n//  //transform: translate(0,-10px);\n//  //.ant-popover-arrow{\n//  //  //display: none;\n//  //}\n//}\n//\n//.ant-popover-inner-content{\n//  padding: 0;\n//}\n//\n.aiot-input-select-select:not(.aiot-design-select-multiple){\n  .aiot-design-select-selector{\n    height: 28px!important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
